import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import SectionGallery from "@components/global/SectionGallery"
import ProductServicesTheBallroomMaps from "@components/pages/products-services/product-services-the-ballroom-maps"
import ProductsServicesConcessionsLocation from "@components/pages/products-services/products-services-concessions-location"
import { ServicesContent } from "@components/pages/services/services-content"
import { getPageBySlug } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { linkProductsServices } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { convertJson, extractMeta, imgUrl } from "src/mixins"

function TheBallroomPage({ data, locale }) {
  const pageData = data?.meta
  const hero = extractMeta(pageData, "hero")
  const content = extractMeta(pageData, "features")
  const gallery = extractMeta(pageData, "gallery")
  const maps = extractMeta(pageData, "google_maps")
  return (
    <>
      <Cover
        title={hero && hero[`title_${locale}`]}
        text={hero && hero[`description_${locale}`]}
        img={imgUrl(hero?.banner_image_mobile)}
        imgMd={imgUrl(hero?.banner_image_desktop)}
        imgOverlay={20}
        imgHeight="h-vh-100"
        scrollHint
        scrollHintPosition="right"
        className="sc-the-ballroom-cover"
        breadcrumb={
          <Breadcrumb
            path={[
              {
                title: translations[`product_services_${locale}`],
                url: linkProductsServices,
              },
              { title: data[`title_${locale}`] },
            ]}
            theme="dark"
          />
        }
      />
      {convertJson(content?.items)?.map((item, i) => (
        <ServicesContent
          key={`the-ballroom-features-${i}`}
          data={item}
          locale={locale}
          alt={(i + 1) % 2 === 0}
        />
      ))}
      <SectionGallery
        sectionName="sc-the-ballroom-gallery"
        theme="dark"
        hasTitle
        data={convertJson(gallery?.items)}
      />
      <ProductServicesTheBallroomMaps data={maps} locale={locale} />
    </>
  )
}
export default TheBallroomPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("the-ballroom")
  return {
    props: {
      seo: {
        title: (data && data[`title_${locale}`]) || "The Ballroom",
        description: metaDesc[`product_landing_${locale}`],
      },
      page: "the-ballroom",
      data,
      locale,
    },
    revalidate: 60,
  }
}
